/**
 * Смена адреса почты — отдельным окном.
 *
 * Отдельно от правки имени и аватара: это не «настройка внешнего вида»,
 * а действие, после которого меняется вход в аккаунт.
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useRequestEmailChange } from "../api/queries";
import { errorMessage } from "../lib/authForm";
import { Dialog } from "./Dialog";

export function ChangeEmailDialog({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  const request = useRequestEmailChange();

  const [newEmail, setNewEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pending, setPending] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setError(null);
    try {
      const response = await request.mutateAsync({ newEmail: newEmail.trim(), password });
      setPending(response.pendingEmail ?? newEmail.trim());
    } catch (failure) {
      setError(errorMessage(failure));
    }
  };

  return (
    <Dialog title={t("profile.emailTitle")} onClose={onClose}>
      {pending ? (
        <div className="space-y-4">
          <p className="rounded-xl border border-sage/40 bg-sage/10 px-3 py-2 text-sm text-sage">
            {t("profile.emailSent", { email: pending })}
          </p>
          <button type="button" className="btn-primary w-full" onClick={onClose}>
            {t("common.close")}
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          <div>
            <label className="label" htmlFor="change-email">
              {t("profile.newEmail")}
            </label>
            <input
              id="change-email"
              type="email"
              className="field"
              autoComplete="email"
              value={newEmail}
              onChange={(event) => setNewEmail(event.target.value)}
            />
          </div>

          <div>
            <label className="label" htmlFor="change-email-password">
              {t("auth.field.password")}
            </label>
            <input
              id="change-email-password"
              type="password"
              className="field"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          {error && <p className="text-xs text-rust">{error}</p>}

          <button
            type="button"
            className="btn-primary w-full"
            disabled={!newEmail.trim() || !password || request.isPending}
            onClick={() => void submit()}
          >
            {request.isPending ? t("forgot.sending") : t("profile.changeEmail")}
          </button>
        </div>
      )}
    </Dialog>
  );
}
